import React, { createContext, useState } from "react";

export let fmArtistsContext = createContext(0);

const ArtistsContext = ({ children }) => {
  let [artistMsg, setArtistMsg] = useState("");

  let [filtrationDetails, setFiltrationDetails] = useState({
    search_query: "",
    label_keys: [],
    main_artist: null,
    top_five_artists: 0,
    only_trashed: 0,
  });

  let [isFiltrationLoading, setIsFiltrationLoading] = useState(false);

  let fmArtistsLifting = {
    artistMsg,
    setArtistMsg,
    filtrationDetails,
    setFiltrationDetails,
    isFiltrationLoading,
    setIsFiltrationLoading,
  };

  return (
    <>
      <fmArtistsContext.Provider value={{ ...fmArtistsLifting }}>{children}</fmArtistsContext.Provider>
    </>
  );
};

export default ArtistsContext;
